export default __webpack_public_path__ + "static/media/cbb-logo.d0541a48.svg";